import { TitleButton } from '@/common/buttons/TitleButton';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ValList } from '@/common/val/ValList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { McdLedgerLineList } from '../mcdLedgerLine/McdLedgerLineList';

export const McdLedgerDetail = () => {
  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'mcdLedgerLine', label: 'Lines', content: <McdLedgerLineList mcdLedgerObj={entityObj} /> },
    { id: 'val', label: 'Validations', content: <ValList parentEntity="MCD_LEDGER" parentEntityId={entityObj.id} /> },
  ];

  const submitToPymt = () => {
    rsrc.store('sc', 'LEDGER_PYMT_STORE_PLUGIN', { entity: 'MCD_LEDGER', id: entityObj.id });
  };

  const augButtons = (buttons) => {
    buttons.push(<TitleButton icon={fas.faHandHoldingUsd} toolTip="Submit to Payment" onClick={submitToPymt} />);
  };

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
